import getField from '../getField'

const getShortName = user => getField(user, 'userProfile.firstName') || getField(user, 'userProfile.fullName')

export default getShortName



// WEBPACK FOOTER //
// ./src/utilities/Data/User/getShortName.js